import { round } from '../../../utils/NumberUtil'
import { getOptions } from '../EChartUtils'

class _Bar {
    constructor(obj) {
        this.obj = obj
    }

    getDefaultOptions = () => {
        return {
            name: 'bar chart',
            type: 'bar',
            data: [],
            areaStyle: {
                normal: {},
            },
            itemStyle: {
                normal: {
                    color: 'blue',
                },
            },
        }
    }

    updateObj = (changes) => {
        this.obj = { ...this.obj, ...changes }
    }

    getJson = (bandCorrection) => {
        const options = getOptions(this.obj, this.getDefaultOptions(), {
            color: () => (
                {
                    areaStyle: {
                        normal: {
                            color: this.obj.color,
                            opacity: 1,
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: this.obj.color,
                            opacity: 1,
                        },
                    },
                }),
        })
        if (bandCorrection && this.obj.isPiezo && !this.obj.dontUseBandCorrection) { // #tpa: utilisé sur suivi piézo
            options.data = options.data.map(d => {
                if (d.value) {
                    return { ...d, value: [d.value[0], d.value[1] !== null ? round(d.value[1] + 1000) : null, d.value[2], d.value[3]] }
                }
                return [d[0], d[1] !== null ? round(d[1] + 1000) : null, d[2], d[3]]
            })
        }
        return options
    }
}

export default function Bar(args) {
    return new _Bar(args)
}
